var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScalingsolution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150",
    transform: "translate(-567 -1710)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(567 1710)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(577.305 1720.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3418",
    "data-name": "Path 3418",
    d: "M32.466,7.932l-.589.187-3.138.28-.886,1.415-.643-.2-2.5-2.252L24.35,6.187l-.485-1.249L22.295,3.53l-1.852-.362-.043.847,1.814,1.77L23.1,6.831l-1,.522-.812-.239-1.217-.508.041-.982-1.6-.657-.53,2.308-1.61.365.159,1.288,2.1.4L19,7.274l1.731.256.8.471h1.291l.884,1.77,2.343,2.377-.172.924-1.889-.241L20.726,14.48,18.376,17.3l-.306,1.249h-.844l-1.572-.725-1.527.725.38,1.611.664-.766,1.168-.036L16.258,20.8l.968.283.967,1.086,1.578-.444,1.8.285,2.094.563,1.046.123,1.773,2.012,3.421,2.012-2.213,4.227-2.336,1.086-.886,2.416-3.38,2.257-.36,1.3A19.667,19.667,0,0,0,32.466,7.932Z",
    transform: "translate(3.579 0.804)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3419",
    "data-name": "Path 3419",
    d: "M21.957,28.074l-1.434-2.659,1.316-2.743-1.316-.394-1.478-1.484-3.275-.735-1.087-2.274v1.35H14.2l-2.822-3.826V12.166L9.314,8.8l-3.285.585H3.816L2.7,8.658l1.42-1.126-1.417.327A19.666,19.666,0,0,0,19.693,37.475a20.616,20.616,0,0,0,2.471-.172l-.206-2.386s.9-3.543.9-3.663S21.957,28.074,21.957,28.074Z",
    transform: "translate(-0.004 1.911)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    d: "M6.409,6.35l3.5-.488,1.612-.884,1.814.523,2.9-.16.993-1.561,1.448.238,3.517-.33.969-1.068,1.367-.913L26.458,2l.7-.107A19.628,19.628,0,0,0,3.6,7.16h.01Zm13.2-4.392L21.624.851l1.291.746L21.046,3.02,19.261,3.2l-.8-.522Zm-5.956.162.888.37,1.162-.37.633,1.1-2.683.7-1.29-.755S13.628,2.354,13.657,2.12Z",
    transform: "translate(0.907)",
    fill: "#fafafa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalingsolution);
export default __webpack_public_path__ + "static/media/scalingsolution.d763d7013e54081c9203199567aa7fd6.svg";
export { ForwardRef as ReactComponent };